module.exports = __webpack_public_path__ + "img/ticket_zhu2.d99e4404.png";